<template>
    <div class="form">
        <!--步骤条-->
        <steps :active="active" :isUpload="isUpload" :emsNeeded="matterInfo.emsNeeded"></steps>
        <!--第一页（申报信息）-->
        <div v-show="active === 0">
            <!--公安机关选择-->
            <select-police :matterInfo="matterInfo" :informationShowData="informationShowData"
                           :declareInfo="declareInfo" ref="selectpolice"></select-police>
            <!-- 申请人信息 -->
            <application-person-info1 :applicationInfo="applicationInfo"  matNum="hj0107" ref="applicationPersonInfo1Method"
                                      @getApplicationPersonInfo1="setApplicationPersonInfo1"></application-person-info1>
            <!-- 随迁人员信息 -->
            <!--            <family-info :data="data" ref="familyInfoMethod"></family-info>-->
            <div class="btn-submit-div btn-submit-back">
                <van-button type="info" size="large" @click="next(1)">下一步</van-button>
            </div>
        </div>
        <!--第二页（附件上传）-->
        <div v-show="active === 1" v-if="isUpload">
            <p class="title">附件上传
                <span class="text-danger">
                    (注:材料图片应展现全貌、清晰可辨。应业务要求，照片大小不超过2MB。)
                </span>
            </p>
            <van-cell-group v-for="(item, index) in matterInfo.manifests" :key="index">
                <upload-image :title="item.itemName" :required="item.requred === 'Y'"
                              :uploadPath="`${path}?guid=${item.guid}&idx=${index}`"
                              :matId='item.guid' ref="imageChildFunction" :informationShowData="informationShowData"
                              @setImageInfo="getImageInfo"
                              @setIsImages="getIsImages"></upload-image>
            </van-cell-group>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" @click="up(0)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(2)">下一步</van-button>
            </div>
        </div>
        <!-- 第三页（办理方式）-->
        <div v-show="active === 2">
            <!--邮寄信息-->
            <mailing @setNextUpShow="getNextUpShow" :matterInfo="matterInfo" :declareInfo="declareInfo"
                     v-if="matterInfo.emsNeeded === 'Y'"
                     ref="mailingChildFunction"
                     @setMailingData="getMailingData" @getStatus="getStatus"></mailing>
            <div class="btn-submit-div-double" v-if="nextUpShow">
                <van-button class="btn-left" type="info" size="large" @click="up(1)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(3)">下一步</van-button>
            </div>
        </div>
        <!--第四页（提交确认）-->
        <div v-show="active === 3">
            <!--展示信息-->
            <information-show :informationShowData="informationShowData" @setActive="getActive"></information-show>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" :matterInfo='matterInfo'
                            @click="matterInfo.emsNeeded === 'Y'?up(2):up(1)">上一步
                </van-button>
                <van-button class="btn-right" type="info" size="large" @click="submit">提交</van-button>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Description:
     * Author:
     * Date:
     * Time:
     */

    import {Button, Toast, CellGroup, Dialog, Cell} from 'vant'
    import {matterApiMap} from '@/api/matter'
    import Steps from "@/components/declare/Steps"
    import SelectPolice from "@/components/declare/SelectPolice"
    import ApplicationPersonInfo1 from '@/components/declare/ApplicationPersonInfowh'
    import UploadImage from "@/components/upload-image/UploadImage"
    import Mailing from "@/components/declare/Mailing"
    import InformationShow from "@/components/declare/InformationShow";
    import {taskApiMap} from "@/api/task";

    export default {
        name: "HJ0107",
        components: {
            InformationShow,
            Mailing,
            UploadImage,
            Steps,
            SelectPolice,
            ApplicationPersonInfo1,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [CellGroup.name]: CellGroup,
            [Dialog.name]: Dialog,
            [Cell.name]: Cell,
        },
        data() {
            return {
                flag: '', //办理方式传过来的状态
                active: 0, // 控制步骤条当前位置
                matterInfo: {}, // 存放事项信息
                isUpload: false, // 判断是否有附件上传
                userInfo: {}, // 存放个人信息
                path: global.storageUrl + '/storage/upload', // 上传图片的地址
                isImagesList: [], // 存放每组上传图片是否已经上了
                nextUpShow: true, // 控制邮寄信息'上一页'和'下一页'显示与隐藏
                informationShowData: { // 展示信息
                    deptName: '', // 公安机关中文名（展示信息）
                    name: '', // 姓名（展示信息）
                    idNum: '', // 身份证（展示信息）
                    address: '', // 地址（展示信息）
                    phone: '', // 联系方式（展示信息）
                    isUpload: false, // 是否有附件上传状态（展示信息）
                    imageTitleList: [], // 附件标题列表（展示信息）
                    imageList: [], // 附件列表（展示信息）
                    mailingShow: '', // 是否有邮寄信息状态（展示信息）
                    mailingStatus: '', // 邮寄流程（展示信息）：1：办结送件，2：双程，3：上门取件
                    takeData: {}, // 取件信息（展示信息）
                    takePrice: '', // 取件费用（展示信息）
                    receiveData: {}, // 送件信息（展示信息）
                    receivePrice: '', // 送件费用（展示信息）
                    totalPrice: '' // 工本费（展示信息）
                },
                declareInfo: { //基本信息1，字段不变
                    matNum: '', // 事项编号
                    deptId: '', // 所选公安部门id
                    linkPhone: '', // 电话号码
                    netProjectType: 'WEI',  // 申报方式(PCP|WIN|WEI|WAP|APP)
                    tskSource: 'SYS', // 申报来源(写死)
                    isMailMertal: '0', // 邮寄方式 101：EMS邮寄线上支付
                    wfId: '', // 工作流id
                    manifests: [], // 存放附件信息
                    accountId: this.$cookie.getUser().acountId, // 注册的电话号码
                    addressGuidQj: '', // 邮寄地址上门Guid
                    addressGuidSh: '', // 邮寄地址送件Guid
                    qjMoney: '', // 取件费用
                    shMoney: '', // 收件费用
                    gbMoney: '', // 工本费
                    emsConfig: '', // 邮寄流程：1：办结送件，2：双程，3：上门取件
                    linkAddress: '',
                },
                body: { // 基本信息2 不变化信息
                    sqrxm: this.$cookie.getUser().realName, // 申请人名称
                    sqrgmsfhm: this.$cookie.getUser().idNum,
                    sqrlxfs: '',
                    sqrdz: '',
                    pcsmcbm: '',
                    pcsmc: '',
                    sxmc: '',
                    sxmcid: '',
                },
                customFormInfo: {
                    username: '',
                    deptId: '',
                    isMail: true
                },
                applicationPersonInfo1Flag: false, // 校验申请人信息的结果
                applicationInfo: {}, // 申请人信息
                // data: {
                //     family: {},
                //     num: 0,
                //     max: 3
                // }
            }
        },
        mounted() {
            this.getMatterInfo()
            this.getUserInfo()
        },
        beforeRouteLeave(to, from, next) { // 对图片预览过程中，直接使用浏览器返回上一页，关闭图片预览
            for (let index in this.$refs.imageChildFunction) {
                this.$refs.imageChildFunction[index].closePreview()
            }
            next()
        },
        methods: {
            /**
             * 选择的办理方式
             * status false:窗口办理 true:邮寄服务
             */
            getStatus(status) {
                this.flag = status
            },
            /**
             * 获取事项信息
             */
            async getMatterInfo() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(`${matterApiMap.getMattersEtDetail}/${this.$route.query.guid}`)
                    this.matterInfo = res.data.data
                    this.declareInfo.matNum = res.data.data.matNum
                    this.body.sxmc = res.data.data.matName
                    this.body.sxmcid = res.data.data.matNum
                    if (this.matterInfo.manifests.length) {
                        this.isUpload = true
                        this.informationShowData.isUpload = true
                        this.informationShowData.imageTitleList = this.matterInfo.manifests
                    }
                    this.declareInfo.emsConfig = this.matterInfo.emsConfig
                    this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                    this.informationShowData.mailingStatus = this.matterInfo.emsConfig
                    if (this.matterInfo.emsNeeded === 'Y') {
                        this.declareInfo.isMailMertal = '101'
                    }
                    this.declareInfo.wfId = this.matterInfo.wfId
                } catch (error) {
                    console.log(error)
                }
            },

            /**
             * 获取个人信息
             */
            async getUserInfo() {
                if (this.$cookie.loginState()) {
                    this.userInfo = this.$cookie.getUser()
                    let province = this.userInfo.province === null || this.userInfo.province === undefined ? "" : this.userInfo.province
                    let city = this.userInfo.city === null || this.userInfo.city === undefined ? "" : this.userInfo.city
                    let area = this.userInfo.area === null || this.userInfo.area === undefined ? "" : this.userInfo.area
                    let address = this.userInfo.address === null ? "" : this.userInfo.address
                    let fullAddress = province.toString() + city.toString() + area.toString() + address.toString()
                    if (fullAddress === '0') {
                        fullAddress = ''
                    }
                    this.userInfo.fullAddress = fullAddress
                    this.declareInfo.linkAddress = fullAddress
                    this.body.sqrdz = fullAddress
                    if (fullAddress === '') {
                        this.declareInfo.linkAddress = '无'
                        this.body.sqrdz = '暂无'
                    }
                }
            },
            setApplicationPersonInfo1(value) {
                this.applicationPersonInfo1Flag = value
            },

            /**
             * 下一页
             * @param index 传入每一页下标
             */
            next(index) {
                Toast.clear()
                if (index === 1) { // 申报信息页面验证
                    this.$refs.selectpolice.setDeptId() // 部门赋值
                    if (!this.declareInfo.deptId) {
                        Toast('请选择公安机关')
                        return
                    }
                    // 申请人信息验证
                    this.$refs.applicationPersonInfo1Method.validApplicationPersonInfo1()
                    if (!this.applicationPersonInfo1Flag) {
                        return
                    }
                    this.applicationInfo.nlhdpcs = ''

                    // 更新展示和基本信息
                    this.informationShowData.name = this.applicationInfo.xm
                    this.informationShowData.idNum = this.applicationInfo.gmsfhm
                    this.informationShowData.address = this.declareInfo.linkAddress
                    this.informationShowData.phone = this.applicationInfo.lxfs
                    this.declareInfo.linkPhone = this.applicationInfo.lxfs
                    this.body.sqrlxfs = this.applicationInfo.lxfs

                    // 随迁人员信息验证
                    // this.$refs.familyInfoMethod.setFamilyInfo()
                    if (this.isUpload) { // 根据是否有上传附件判断进入'附件上传'或'办理方式'
                        this.active = 1
                    } else if (this.matterInfo.emsNeeded === 'Y') {
                        this.active = 2
                    } else {
                        this.active = 3
                    }
                } else if (index === 2) { // 附件上传页面验证
                    this.declareInfo.manifests = []
                    this.informationShowData.imageList = []
                    this.isImagesList = []
                    for (let index in this.$refs.imageChildFunction) { // 上传图片赋值
                        this.$refs.imageChildFunction[index].passImageValue()
                    }
                    for (let index in this.isImagesList) { // 判断必上传的图片是否上传
                        if (!this.isImagesList[index]) {
                            Toast('请选择上传附件')
                            return
                        }
                    }
                    if (this.matterInfo.emsNeeded === 'Y') {
                        this.active = 2
                    } else {
                        this.active = 3
                    }
                } else if (index === 3) {
                    this.$refs.mailingChildFunction.passMailingValue()
                    if (this.flag === false) { // false:窗口办理 true:邮寄服务
                        this.informationShowData.mailingShow = false
                        this.declareInfo.isMailMertal = '0'
                        this.active = 3
                    } else { // 邮寄服务
                        this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                        this.declareInfo.isMailMertal = '101' // 办理方式：'0'窗口办理，'101'邮寄

                        if (this.declareInfo.emsConfig === '3' && !this.declareInfo.addressGuidQj) {
                            Toast('请添加地址')
                            return
                        }
                        if (this.declareInfo.emsConfig === '1' && !this.declareInfo.addressGuidSh) {
                            Toast('请添加地址')
                            return
                        }
                        if (this.declareInfo.emsConfig === '2' && !this.declareInfo.addressGuidQj && !this.declareInfo.addressGuidSh) {
                            Toast('请至少选择一种邮寄方式')
                            return
                        }

                        if (this.declareInfo.addressGuidQj && this.declareInfo.addressGuidSh) {//两者都选
                            this.informationShowData.mailingStatus = '2'
                        } else if (this.declareInfo.addressGuidQj) { // 二选一
                            // 选择了取件地址
                            this.informationShowData.mailingStatus = '3'
                            this.declareInfo.addressGuidSh = ''
                        } else if (this.declareInfo.addressGuidSh) {
                            // 选择了收件地址
                            this.informationShowData.mailingStatus = '1'
                            this.declareInfo.addressGuidQj = ''
                        }
                    }

                    this.active = 3

                }
            },

            /**
             * 上一页
             * @param index 传入每一页下标
             */
            up(index) {
                if (index === 0) {
                    this.active = 0
                } else if (index === 1) {
                    this.active = 1
                } else if (index === 2) {
                    this.active = 2
                }
            },

            /**
             * 接收上传图片组件传来的image列表
             * @param value image列表
             */
            getImageInfo(value) {
                if (value.length > 0) {
                    for (let index in value) {
                        this.declareInfo.manifests.push(value[index])
                        this.informationShowData.imageList.push(value[index])
                    }
                }
            },

            /**
             * 接收是否上传图片的状态
             * @param value 是否上传了图片状态
             */
            getIsImages(value) {
                this.isImagesList.push(value)
            },

            /**
             * 接收邮寄信息组件传来的是否展示邮寄信息的'上一页'和'下一页'的状态
             * @param value 布尔值
             */
            getNextUpShow(value) {
                this.nextUpShow = value
            },

            /**
             * 接收邮寄信息组件
             * @param value 布尔值
             */
            getMailingData(value) {
                this.declareInfo.addressGuidQj = value.addressGuidQj
                this.declareInfo.addressGuidSh = value.addressGuidSh
                this.declareInfo.qjMoney = value.qjMoney
                this.declareInfo.shMoney = value.shMoney
                this.declareInfo.gbMoney = value.gbMoney
                this.informationShowData.takeData = value.takeData
                this.informationShowData.takePrice = value.qjMoney
                this.informationShowData.receiveData = value.receiveData
                this.informationShowData.receivePrice = value.shMoney
                this.informationShowData.totalPrice = value.gbMoney
            },

            /**
             * 接收事项信息展示组件传来的值，改变active参数
             * @param value 传来的下标，改变active参数
             */
            getActive(value) {
                this.active = value
            },
            /**
             * 提交时，需要把标准化事项和定制化事项的两个数据对象合并
             * @return {Promise<void>}
             */
            async submit() {
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '提交中...'
                })
                try {
                    // 派出所名称和派出所编号
                    this.body.pcsmc = this.informationShowData.deptName
                    this.body.pcsmcbm = this.declareInfo.deptId

                    this.applicationInfo.sqr3_ysqrgx = ''
                    this.applicationInfo.sqr3_xm = ''
                    this.applicationInfo.sqr3_xb = ''
                    this.applicationInfo.xfyd = ''

                    this.applicationInfo.hjdz = ''
                    this.applicationInfo.sspcs = ''
                    this.applicationInfo.hfyy = ''
                    this.applicationInfo.xb = ''
                    this.applicationInfo.sljg = this.informationShowData.allDeptName
                    this.applicationInfo.lxdh = this.applicationInfo.lxfs
                    this.applicationInfo.sqly = '' // 申请理由
                    this.body['data'] = this.applicationInfo // 对接信息
                    const data = {
                        taskApply: this.declareInfo,
                        body: this.body
                    }

                    const res = await this.$httpUtils.postGatewayUtils(taskApiMap.hzTsks, data)
                    if (res.data.succ) {
                        Toast.clear()
                        if (this.informationShowData.mailingShow === 'Y') {
                            Dialog.alert({
                                title: '您申请的【全省】应征入伍注销户口 已受理,将在3个工作日内处理。',
                                message: `您的办件编号为:${res.data.data}`
                            }).then(() => {
                                this.$router.push('/myHandlingList')
                            })

                        } else {
                            Dialog.alert({
                                title: '您申请的【全省】应征入伍注销户口 已受理,将在3个工作日内处理。',
                                message: `您的办件编号为:${res.data.data}`
                            }).then(() => {
                                this.$router.push('/myHandlingList')
                            })
                        }

                    } else {

                        Toast.clear()
                        if (res.data.status===201) {
                            Toast.fail('申报失败，当天同一事项以申报两次达到限制请勿重复申报！')
                        }else{
                            Toast.fail('申报失败，当前网络波动请退出登录后重新申报！！！')
                        }

                    }
                } catch (error) {
                    console.log(error)
                    Toast.clear()
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@assets/css/views/matter/declare/standard-matter/StandardMatter.less";
</style>
<style>
    .text-danger{
        color:red;
    }
</style>




<!--<template>-->
<!--    <div class="form">-->
<!--        &lt;!&ndash;步骤条&ndash;&gt;-->
<!--        <steps :active="active" :isUpload="isUpload" :emsNeeded="matterInfo.emsNeeded"></steps>-->
<!--        &lt;!&ndash;第一页（申报信息）&ndash;&gt;-->
<!--        <div v-show="active === 0">-->
<!--            &lt;!&ndash;公安机关选择&ndash;&gt;-->
<!--            <select-police :matterInfo="matterInfo" :declareInfo="declareInfo" ref="selectpolice"-->
<!--                           :informationShowData="informationShowData"></select-police>-->
<!--            &lt;!&ndash;基本信息&ndash;&gt;-->
<!--            <p class="title">申请人信息</p>-->
<!--            <van-cell-group>-->
<!--                &lt;!&ndash;申请人姓名&ndash;&gt;-->
<!--                <van-field required label="姓名" :value="body.sqrxm" input-align="right" readonly/>-->
<!--                &lt;!&ndash;申请人性别&ndash;&gt;-->
<!--                <van-field required readonly clickable label="性别" input-align="right" is-link-->
<!--                           :value="sex" placeholder="请选择"-->
<!--                           @click="showPickerSex = true"/>-->
<!--                <van-popup v-model="showPickerSex" position="bottom">-->
<!--                    <van-picker show-toolbar :columns="columnsSex" value-key="title" @cancel="showPickerSex = false"-->
<!--                                @confirm="onConfirmSex"/>-->
<!--                </van-popup>-->
<!--                &lt;!&ndash;申请人出生日期&ndash;&gt;-->
<!--                <van-field required readonly clickable label="出生日期" input-align="right" is-link-->
<!--                           :value="body.data.csrq"-->
<!--                           placeholder="请选择"-->
<!--                           @click="showPickerBirthDate = true"/>-->
<!--                <van-popup v-model="showPickerBirthDate" position="bottom">-->
<!--                    <van-datetime-picker v-model="currentDate" type="date" :max-date="maxDate" :min-date="minDate"-->
<!--                                         @cancel="showPickerBirthDate = false" @confirm="onConfirmBirthdayDate"/>-->
<!--                </van-popup>-->
<!--                &lt;!&ndash;申请人公民身份号码&ndash;&gt;-->
<!--                <van-field required label="公民身份号码" input-align="right"-->
<!--                           :value="body.sqrgmsfhm.replace(/^(\d{3})\d{10}(\d+)/, '$1**********$2')"-->
<!--                           readonly/>-->
<!--                &lt;!&ndash;申请人户籍地址&ndash;&gt;-->
<!--                <van-field required v-model="sqrProvince" label="户籍地址" placeholder="请选择省份" is-link readonly input-align="right"-->
<!--                           @click="showSqrProvince = true"/>-->
<!--                <van-popup v-model="showSqrProvince" position="bottom">-->
<!--                    <van-picker :columns="provinceList" show-toolbar value-key="title" @cancel="showSqrProvince = false"-->
<!--                                @confirm="onConfirmSqrProvince"/>-->
<!--                </van-popup>-->
<!--                <van-field v-model="sqrCity" placeholder="请选择市区" is-link readonly input-align="right"-->
<!--                           @click="showSqrCity = true" v-if="sqrCityShow"/>-->
<!--                <van-popup v-model="showSqrCity" position="bottom">-->
<!--                    <van-picker :columns="cityList" show-toolbar value-key="title" @cancel="showSqrCity = false"-->
<!--                                @confirm="onConfirmSqrCity"/>-->
<!--                </van-popup>-->
<!--                <van-field v-model="sqrArea" placeholder="请选择县区" is-link readonly input-align="right"-->
<!--                           @click="showSqrArea = true" v-if="sqrAreaShow"/>-->
<!--                <van-popup v-model="showSqrArea" position="bottom">-->
<!--                    <van-picker :columns="areaList" show-toolbar value-key="title" @cancel="showSqrArea = false"-->
<!--                                @confirm="onConfirmSqrArea"/>-->
<!--                </van-popup>-->
<!--                <van-field required input-align="right" type="textarea"-->
<!--                           v-model="sqrdz"-->
<!--                           placeholder="请输入区划内详细地址" rows="1" autosize clearable/>-->
<!--                &lt;!&ndash;申请人所属派出所&ndash;&gt;-->
<!--                <van-field required label="所属派出所" input-align="right" v-model="body.data.sspcs"-->
<!--                           placeholder="请输入所属派出所" clearable/>-->
<!--                &lt;!&ndash;申请人现服役地&ndash;&gt;-->
<!--                <van-field required label="现服役地" input-align="right" v-model="body.data.xfyd"-->
<!--                           placeholder="请输入现服役地" clearable/>-->
<!--                &lt;!&ndash;申请人联系电话&ndash;&gt;-->
<!--                <van-field required label="联系电话" input-align="right" v-model="body.sqrlxfs"-->
<!--                           placeholder="请输入联系电话" clearable/>-->
<!--            </van-cell-group>-->
<!--            <div class="btn-submit-div btn-submit-back">-->
<!--                <van-button type="info" size="large" @click="next(1)">下一步</van-button>-->
<!--            </div>-->
<!--        </div>-->
<!--        &lt;!&ndash;第二页（附件上传）&ndash;&gt;-->
<!--        <div v-show="active === 1" v-if="isUpload">-->
<!--            <p class="title">附件上传-->
<!--                <span class="text-danger">-->
<!--                    (注:材料图片应展现全貌、清晰可辨。应户政要求，照片大小不超过1MB，为避免无法正常提交，请使用微信拍照图片上传。)-->
<!--                </span>-->
<!--            </p>-->
<!--            <van-cell-group v-for="(item, index) in matterInfo.manifests" :key="index">-->
<!--                <upload-image :title="item.itemName" :required="item.requred === 'Y'"-->
<!--                              :uploadPath="`${path}?guid=${item.guid}&idx=${index}`"-->
<!--                              :matId='item.guid' ref="imageChildFunction" :informationShowData="informationShowData"-->
<!--                              @setImageInfo="getImageInfo"-->
<!--                              @setIsImages="getIsImages"></upload-image>-->
<!--            </van-cell-group>-->
<!--            <div class="btn-submit-div-double">-->
<!--                <van-button class="btn-left" type="info" size="large" @click="up(0)">上一步</van-button>-->
<!--                <van-button class="btn-right" type="info" size="large" @click="next(2)">下一步</van-button>-->
<!--            </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; 第三页（办理方式）&ndash;&gt;-->
<!--        <div v-show="active === 2">-->
<!--            &lt;!&ndash;邮寄信息&ndash;&gt;-->
<!--            <mailing @setNextUpShow="getNextUpShow" :matterInfo="matterInfo" :declareInfo="declareInfo"-->
<!--                     v-if="matterInfo.emsNeeded === 'Y'"-->
<!--                     ref="mailingChildFunction"-->
<!--                     @setMailingData="getMailingData" @getStatus="getStatus"></mailing>-->
<!--            <div class="btn-submit-div-double" v-if="nextUpShow">-->
<!--                <van-button class="btn-left" type="info" size="large" @click="up(1)">上一步</van-button>-->
<!--                <van-button class="btn-right" type="info" size="large" @click="next(3)">下一步</van-button>-->
<!--            </div>-->
<!--        </div>-->
<!--        &lt;!&ndash;第四页（提交确认）&ndash;&gt;-->
<!--        <div v-show="active === 3">-->
<!--            &lt;!&ndash;展示信息&ndash;&gt;-->
<!--            <information-show :informationShowData="informationShowData" :showPropList="baseInfoList"-->
<!--                              @setActive="getActive"></information-show>-->
<!--            <div class="btn-submit-div-double">-->
<!--                <van-button class="btn-left" type="info" size="large" :matterInfo='matterInfo'-->
<!--                            @click="matterInfo.emsNeeded === 'Y'?up(2):up(1)">上一步-->
<!--                </van-button>-->
<!--                <van-button class="btn-right" type="info" size="large" @click="submit">提交</van-button>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</template>-->

<!--<script>-->
<!--    /**-->
<!--     * Description: 标准事项-->
<!--     * Author: wangyan-->
<!--     * Date: 2019-04-23-->
<!--     * Time: 15:17-->
<!--     */-->

<!--    import {Button, Toast, CellGroup, Dialog, Cell, Field, Popup, Picker, DatetimePicker} from 'vant'-->
<!--    import {matterApiMap} from '@/api/matter'-->
<!--    import Steps from "@/components/declare/Steps"-->
<!--    import SelectPolice from "@/components/declare/SelectPolice"-->
<!--    import UploadImage from "@/components/upload-image/UploadImage"-->
<!--    import Mailing from "@/components/declare/Mailing"-->
<!--    import InformationShow from "@/components/custom/InformationShow";-->
<!--    // import CustomForm from './custom/CustomForm';-->
<!--    import {taskApiMap} from "@/api/task";-->
<!--    import {baseApiMap} from '@/api/base'-->
<!--    import {dateToString} from '@/utils/time'-->
<!--    import {idCardRegex} from '@/utils/regex'-->

<!--    export default {-->
<!--        name: "StandardMatter",-->
<!--        components: {-->
<!--            InformationShow,-->
<!--            Mailing,-->
<!--            UploadImage,-->
<!--            Steps,-->
<!--            SelectPolice,-->
<!--            // CustomForm,-->
<!--            [Button.name]: Button,-->
<!--            [Toast.name]: Toast,-->
<!--            [CellGroup.name]: CellGroup,-->
<!--            [Dialog.name]: Dialog,-->
<!--            [Cell.name]: Cell,-->
<!--            [Field.name]: Field,-->
<!--            [Popup.name]: Popup,-->
<!--            [Picker.name]: Picker,-->
<!--            [DatetimePicker.name]: DatetimePicker-->
<!--        },-->
<!--        data() {-->
<!--            return {-->
<!--                provinceList: [{ "title": '湖北省', "val": '420000' }], // 省-->
<!--                cityList: [], // 市-->
<!--                areaList: [], // 区县-->
<!--                list: [],-->
<!--                columnsSex: [], // 性别集合-->
<!--                baseInfoList: [], // 展示组件展示的基本信息-->

<!--                flag: '', //办理方式传过来的状态-->
<!--                active: 0, // 控制步骤条当前位置-->
<!--                matterInfo: {}, // 存放事项信息-->
<!--                isUpload: false, // 判断是否有附件上传-->
<!--                userInfo: {}, // 存放个人信息-->
<!--                path: global.storageUrl + '/storage/upload', // 上传图片的地址-->
<!--                isImagesList: [], // 存放每组上传图片是否已经上了-->
<!--                nextUpShow: true, // 控制邮寄信息'上一页'和'下一页'显示与隐藏-->
<!--                informationShowData: { // 展示信息-->
<!--                    deptName: '', // 公安机关中文名（展示信息）-->
<!--                    name: '', // 姓名（展示信息）-->
<!--                    csrq:'',//出生日期(展示信息)-->
<!--                    sex:'',//性别(展示信息)-->
<!--                    idNum: '', // 身份证（展示信息）-->
<!--                    address: '', // 地址（展示信息）-->
<!--                    phone: '', // 联系方式（展示信息）-->
<!--                    sspcs:'',//所属派出所（展示信息）-->
<!--                    xfyd:'',//现服役地（展示信息）-->
<!--                    linkAddress:'',//联系地址(展示信息)-->
<!--                    isUpload: false, // 是否有附件上传状态（展示信息）-->
<!--                    imageTitleList: [], // 附件标题列表（展示信息）-->
<!--                    imageList: [], // 附件列表（展示信息）-->
<!--                    mailingShow: '', // 是否有邮寄信息状态（展示信息）-->
<!--                    mailingStatus: '', // 邮寄流程（展示信息）：1：办结送件，2：双程，3：上门取件-->
<!--                    takeData: {}, // 取件信息（展示信息）-->
<!--                    takePrice: '', // 取件费用（展示信息）-->
<!--                    receiveData: {}, // 送件信息（展示信息）-->
<!--                    receivePrice: '', // 送件费用（展示信息）-->
<!--                    totalPrice: '', // 工本费（展示信息）-->
<!--                    birthAddressOther: '', // 出生地详细地址-->
<!--                    nativeAddressOther: '', // 籍贯详细地址-->
<!--                },-->
<!--                declareInfo: {-->
<!--                    matNum: '', // 事项编号-->
<!--                    deptId: '', // 所选公安部门id-->
<!--                    linkAddress: '', // 联系地址-->
<!--                    linkPhone: '', // 电话号码-->
<!--                    netProjectType: 'WEI',  // 申报方式(PCP|WIN|WEI|WAP|APP)-->
<!--                    tskSource: 'SYS', // 申报来源(写死)-->
<!--                    isMailMertal: '0', // 邮寄方式 101：EMS邮寄线上支付-->
<!--                    wfId: '', // 工作流id-->
<!--                    manifests: [], // 存放附件信息-->
<!--                    accountId: this.$cookie.getUser().acountId, // 注册的电话号码-->
<!--                    addressGuidQj: '', // 邮寄地址上门Guid-->
<!--                    addressGuidSh: '', // 邮寄地址送件Guid-->
<!--                    qjMoney: '', // 取件费用-->
<!--                    shMoney: '', // 收件费用-->
<!--                    gbMoney: '', // 工本费-->
<!--                    emsConfig: '', // 邮寄流程：1：办结送件，2：双程，3：上门取件-->

<!--                },-->
<!--                body: {-->
<!--                    sqrxm:'',   //申报人姓名-->
<!--                    sqrgmsfhm:'',  //申报人身份证-->
<!--                    sqrlxfs:'', //申报人联系方式-->
<!--                    sqrdz:'', //申报人联系地址-->
<!--                    pcsmcbm:'', //派出所名称(受理机关)编号-->
<!--                    pcsmc:'',//派出所名称(受理机关)-->
<!--                    sxmc:'',//事项名称-->
<!--                    sxmcid:'',//事项名称id-->
<!--                    data:{-->
<!--                        xm:'',-->
<!--                        xb:'',-->
<!--                        csrq:'',-->
<!--                        gmsfhm:'',-->
<!--                        lxdh:'',-->
<!--                        hjdz: '',-->
<!--                        sspcs:'',-->
<!--                        xfyd:'',-->
<!--                        sqly:''-->
<!--                   }-->

<!--                },-->
<!--                showPickerRelation: false, // 是否显示与拟落户人关系的选择框-->
<!--                relationList: [], // 与拟落户人关系的集合-->
<!--                currentDate: new Date(), // 申请人出生日期-->
<!--                currentDate1: new Date(), // 拟落户人人出生日期-->
<!--                maxDate: new Date(),-->
<!--                minDate: new Date(1950,1,1),-->

<!--                //申请人户籍地址-->
<!--                sqrProvince:'',-->
<!--                sqrCity:'',-->
<!--                sqrArea:'',-->
<!--                showSqrProvince: false,-->
<!--                showSqrCity: false,-->
<!--                showSqrArea: false,-->
<!--                sqrCityShow: false,-->
<!--                sqrAreaShow: false,-->

<!--                sqrdz:'',-->

<!--                showPickerBirthDate: false, // 是否显示申请人出生日期选择框-->
<!--                showPickerSex: false, // 是否显示申请人性别选择框-->
<!--                relation: '', //与拟落户人关系-->
<!--                sex: '', // 申请人性别显示的名称-->
<!--            }-->
<!--        },-->
<!--        mounted() {-->
<!--            this.getMatterInfo()-->
<!--            this.getUserInfo()-->
<!--            this.getReservationSex()//加载性别-->
<!--            this.getRelation()   //加载与你落户人关系-->
<!--        },-->
<!--        beforeRouteLeave(to, from, next) { // 对图片预览过程中，直接使用浏览器返回上一页，关闭图片预览-->
<!--            for (let index in this.$refs.imageChildFunction) {-->
<!--                this.$refs.imageChildFunction[index].closePreview()-->
<!--            }-->
<!--            next()-->
<!--        },-->
<!--        methods: {-->
<!--            /**-->
<!--             * 选择的办理方式-->
<!--             * status false:窗口办理 true:邮寄服务-->
<!--             */-->
<!--            getStatus(status) {-->
<!--                this.flag = status-->
<!--            },-->
<!--            /**-->
<!--             * 获取事项信息-->
<!--             */-->
<!--            async getMatterInfo() {-->
<!--                try {-->
<!--                    const res = await this.$httpUtils.getCommonUtils(`${matterApiMap.getMattersEtDetail}/${this.$route.query.guid}`)-->
<!--                    this.matterInfo = res.data.data-->
<!--                    this.declareInfo.matNum = res.data.data.matNum-->
<!--                    if (this.matterInfo.manifests.length) {-->
<!--                        this.isUpload = true-->
<!--                        this.informationShowData.isUpload = true-->
<!--                        this.informationShowData.imageTitleList = this.matterInfo.manifests-->
<!--                    }-->
<!--                    this.declareInfo.emsConfig = this.matterInfo.emsConfig-->
<!--                    this.informationShowData.mailingShow = this.matterInfo.emsNeeded-->
<!--                    this.informationShowData.mailingStatus = this.matterInfo.emsConfig-->
<!--                    this.declareInfo.wfId = this.matterInfo.wfId-->
<!--                    this.body.sxmc = this.matterInfo.matName-->
<!--                    this.body.sxmcid =this.matterInfo.matNum-->
<!--                } catch (error) {-->
<!--                    console.log(error)-->
<!--                }-->
<!--            },-->

<!--            /**-->
<!--             * 获取个人信息-->
<!--             */-->
<!--            async getUserInfo() {-->
<!--                if (this.$cookie.loginState()) {-->
<!--                    this.userInfo = this.$cookie.getUser()-->
<!--                    let province = this.userInfo.province === null || this.userInfo.province === undefined ? "" : this.userInfo.province-->
<!--                    let city = this.userInfo.city === null || this.userInfo.city === undefined ? "" : this.userInfo.city-->
<!--                    let area = this.userInfo.area === null || this.userInfo.area === undefined ? "" : this.userInfo.area-->
<!--                    let address = this.userInfo.address === null ? "" : this.userInfo.address-->
<!--                    let fullAddress = province.toString() + city.toString() + area.toString() + address.toString()-->
<!--                    if (fullAddress === '0') {-->
<!--                        fullAddress = '暂无'-->
<!--                    }-->
<!--                    this.userInfo.fullAddress = fullAddress-->
<!--                    this.declareInfo.linkAddress = fullAddress-->
<!--                    this.body.sqrdz=fullAddress-->
<!--                    this.declareInfo.linkPhone = this.userInfo.telephone-->
<!--                    this.informationShowData.phone = this.userInfo.telephone-->
<!--                    this.informationShowData.address = fullAddress-->
<!--                    this.informationShowData.name = this.userInfo.realName-->
<!--                    this.informationShowData.idNum = this.userInfo.idNum-->
<!--                    this.body.sqrxm = this.userInfo.realName-->
<!--                    this.body.sqrlxfs = this.userInfo.telephone-->
<!--                    this.body.sqrgmsfhm = this.userInfo.idNum-->
<!--                    this.body.data.xm=this.userInfo.realName-->
<!--                    this.body.data.lxdh = this. userInfo.telephone-->
<!--                    this.body.data.gmsfhm =this.userInfo.idNum-->
<!--                }-->
<!--            },-->

<!--            /**-->
<!--             * 加载性别-->
<!--             */-->
<!--            getReservationSex() {-->
<!--                this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz.xblb`).then(response => {-->
<!--                    let arr = [];-->
<!--                    if (response.data.succ = true) {-->
<!--                        var arrSex = response.data.data;-->
<!--                        for (var i = 0; i < arrSex.length; i++) {-->
<!--                            arr.push({"title": arrSex[i].title, "val": arrSex[i].val})-->
<!--                        }-->
<!--                    }-->
<!--                    this.$nextTick(() => {-->
<!--                        this.columnsSex = arr-->
<!--                    })-->
<!--                }).catch(err => {-->

<!--                })-->
<!--            },-->

<!--            /**-->
<!--             * 校验第一页表单信息-->
<!--             */-->
<!--            checkOneStep() {-->
<!--                if(!this.body.sqrxm){-->
<!--                    Toast('请输入申请人姓名')-->
<!--                    return false;-->
<!--                }-->
<!--                if(!this.body.data.xb){-->
<!--                    Toast('请选择申请人性别')-->
<!--                    return false;-->
<!--                }-->
<!--                if(!this.body.data.csrq){-->
<!--                    Toast('请选择申请人出生日期')-->
<!--                    return false;-->
<!--                }-->
<!--                if(!this.body.sqrgmsfhm){-->
<!--                    Toast('请输入申请人身份证号')-->
<!--                    return false;-->
<!--                }-->
<!--                if(!this.sqrProvince){-->
<!--                    Toast('请输入申请人户籍省份')-->
<!--                    return false;-->
<!--                }if(!this.sqrCity){-->
<!--                    Toast('请输入申请人户籍市区')-->
<!--                    return false;-->
<!--                }if(!this.sqrArea){-->
<!--                    Toast('请输入申请人户籍地区')-->
<!--                    return false;-->
<!--                }if(!this.sqrdz){-->
<!--                    Toast('请输入申请人户籍详细地址')-->
<!--                    return false;-->
<!--                }-->
<!--                if(!this.body.data.sspcs){-->
<!--                    Toast('请输入所属派出所')-->
<!--                    return false;-->
<!--                }-->
<!--                if(!this.body.data.xfyd){-->
<!--                    Toast('请输入现服役地')-->
<!--                    return false;-->
<!--                }-->
<!--                if(!this.body.sqrlxfs){-->
<!--                    Toast('请输入申请人联系电话')-->
<!--                    return false;-->
<!--                }-->
<!--                if (!(/^1[3456789]\d{9}$/.test(this.body.sqrlxfs))) {-->
<!--                    Toast('请输入正确的联系电话')-->
<!--                    return false;-->
<!--                }-->

<!--                return true-->
<!--            },-->

<!--            /**-->
<!--             * 下一页-->
<!--             * @param index 传入每一页下标-->
<!--             */-->
<!--            next(index) {-->
<!--                Toast.clear()-->
<!--                if (index === 1) { // 申报信息页面验证-->
<!--                    this.$refs.selectpolice.setDeptId() // 部门赋值-->
<!--                    this.body.pcsmc = this.informationShowData.deptName-->
<!--                    this.body.pcsmcbm = this.declareInfo.deptId-->
<!--                    if (!this.declareInfo.deptId) {-->
<!--                        Toast('请选择公安机关')-->
<!--                        return-->
<!--                    }-->
<!--                    this.body.sqrdz=this.sqrProvince + this.sqrCity + this.sqrArea + this.sqrdz;-->
<!--                    this.informationShowData.sex  = '1'===this.body.data.xb?'男':'女'-->
<!--                    this.informationShowData.csrq = this.body.data.csrq;-->
<!--                    this.informationShowData.sspcs = this.body.data.sspcs;-->
<!--                    this.informationShowData.xfyd = this.body.data.xfyd;-->
<!--                    this.informationShowData.linkAddress =this.body.sqrdz-->
<!--                    this.declareInfo.linkAddress = this.body.data.xfyd;-->
<!--                    this.body.data.hjdz = this.sqrProvince + this.sqrCity + this.sqrArea + this.sqrdz;-->
<!--                    this.informationShowData.address = this.body.data.hjdz;-->


<!--                    //校验第一页表单信息-->
<!--                    if (!this.checkOneStep()) {-->
<!--                        return-->
<!--                    }-->
<!--                    if (this.isUpload) { // 根据是否有上传附件判断进入'附件上传'或'办理方式'-->
<!--                        this.active = 1-->
<!--                    } else if (this.matterInfo.emsNeeded === 'Y') {-->
<!--                        this.active = 2-->
<!--                    } else {-->
<!--                        // 到第三页传值-->
<!--                        this.sendCustomInfomation()-->
<!--                        this.active = 3-->
<!--                    }-->
<!--                } else if (index === 2) { // 附件上传页面验证-->
<!--                    this.declareInfo.manifests = []-->
<!--                    this.informationShowData.imageList = []-->
<!--                    this.isImagesList = []-->
<!--                    for (let index in this.$refs.imageChildFunction) { // 上传图片赋值-->
<!--                        this.$refs.imageChildFunction[index].passImageValue()-->
<!--                    }-->
<!--                    for (let index in this.isImagesList) { // 判断必上传的图片是否上传-->
<!--                        if (!this.isImagesList[index]) {-->
<!--                            Toast('请选择上传附件')-->
<!--                            return-->
<!--                        }-->
<!--                    }-->
<!--                    if (this.matterInfo.emsNeeded === 'Y') {-->
<!--                        this.active = 2-->
<!--                    } else {-->
<!--                        // 到第三页传值-->
<!--                        this.sendCustomInfomation()-->
<!--                        this.active = 3-->
<!--                    }-->
<!--                } else if (index === 3) {-->
<!--                    this.$refs.mailingChildFunction.passMailingValue()-->
<!--                    if (this.flag === false) { // false:窗口办理 true:邮寄服务-->
<!--                        this.informationShowData.mailingShow = false-->
<!--                        this.declareInfo.isMailMertal = '0'-->
<!--                        // 到第三页传值-->
<!--                        this.sendCustomInfomation()-->
<!--                        this.active = 3-->
<!--                    } else { // 邮寄服务-->
<!--                        this.informationShowData.mailingShow = this.matterInfo.emsNeeded-->
<!--                        this.declareInfo.isMailMertal = '101' // 办理方式：'0'窗口办理，'101'邮寄-->

<!--                        if (this.declareInfo.emsConfig === '3' && !this.declareInfo.addressGuidQj) {-->
<!--                            Toast('请添加地址')-->
<!--                            return-->
<!--                        }-->
<!--                        if (this.declareInfo.emsConfig === '1' && !this.declareInfo.addressGuidSh) {-->
<!--                            Toast('请添加地址')-->
<!--                            return-->
<!--                        }-->
<!--                        if (this.declareInfo.emsConfig === '2' && !this.declareInfo.addressGuidQj && !this.declareInfo.addressGuidSh) {-->
<!--                            Toast('请至少选择一种邮寄方式')-->
<!--                            return-->
<!--                        }-->

<!--                        if (this.declareInfo.addressGuidQj && this.declareInfo.addressGuidSh) {//两者都选-->
<!--                            this.informationShowData.mailingStatus = '2'-->
<!--                        } else if (this.declareInfo.addressGuidQj) { // 二选一-->
<!--                            // 选择了取件地址-->
<!--                            this.informationShowData.mailingStatus = '3'-->
<!--                            this.declareInfo.addressGuidSh = ''-->
<!--                        } else if (this.declareInfo.addressGuidSh) {-->
<!--                            // 选择了收件地址-->
<!--                            this.informationShowData.mailingStatus = '1'-->
<!--                            this.declareInfo.addressGuidQj = ''-->
<!--                        }-->
<!--                    }-->
<!--                    // 到第三页传值-->
<!--                    this.sendCustomInfomation()-->
<!--                    this.active = 3-->

<!--                }-->
<!--            },-->

<!--            /**-->
<!--             * 上一页-->
<!--             * @param index 传入每一页下标-->
<!--             */-->
<!--            up(index) {-->
<!--                console.log(index)-->
<!--                if (index === 0) {-->
<!--                    this.active = 0-->
<!--                } else if (index === 1) {-->
<!--                    this.active = 1-->
<!--                } else if (index === 2) {-->
<!--                    this.active = 2-->
<!--                }-->
<!--            },-->

<!--            /**-->
<!--             * 接收上传图片组件传来的image列表-->
<!--             * @param value image列表-->
<!--             */-->
<!--            getImageInfo(value) {-->
<!--                if (value.length > 0) {-->
<!--                    for (let index in value) {-->
<!--                        this.declareInfo.manifests.push(value[index])-->
<!--                        this.informationShowData.imageList.push(value[index])-->
<!--                    }-->
<!--                }-->
<!--            },-->

<!--            /**-->
<!--             * 接收是否上传图片的状态-->
<!--             * @param value 是否上传了图片状态-->
<!--             */-->
<!--            getIsImages(value) {-->
<!--                this.isImagesList.push(value)-->
<!--            },-->

<!--            /**-->
<!--             * 接收邮寄信息组件传来的是否展示邮寄信息的'上一页'和'下一页'的状态-->
<!--             * @param value 布尔值-->
<!--             */-->
<!--            getNextUpShow(value) {-->
<!--                this.nextUpShow = value-->
<!--            },-->

<!--            /**-->
<!--             * 接收邮寄信息组件-->
<!--             * @param value 布尔值-->
<!--             */-->
<!--            getMailingData(value) {-->
<!--                this.declareInfo.addressGuidQj = value.addressGuidQj-->
<!--                this.declareInfo.addressGuidSh = value.addressGuidSh-->
<!--                this.declareInfo.qjMoney = value.qjMoney-->
<!--                this.declareInfo.shMoney = value.shMoney-->
<!--                this.declareInfo.gbMoney = value.gbMoney-->
<!--                this.informationShowData.takeData = value.takeData-->
<!--                this.informationShowData.takePrice = value.qjMoney-->
<!--                this.informationShowData.receiveData = value.receiveData-->
<!--                this.informationShowData.receivePrice = value.shMoney-->
<!--                this.informationShowData.totalPrice = value.gbMoney-->
<!--            },-->

<!--            /**-->
<!--             * 接收事项信息展示组件传来的值，改变active参数-->
<!--             * @param value 传来的下标，改变active参数-->
<!--             */-->
<!--            getActive(value) {-->
<!--                this.active = value-->
<!--            },-->
<!--            /**-->
<!--             * 提交时，需要把标准化事项和定制化事项的两个数据对象合并-->
<!--             * @return {Promise<void>}-->
<!--             */-->
<!--            async submit() {-->
<!--                Toast.loading({-->
<!--                    duration: 0,       // 持续展示 toast-->
<!--                    forbidClick: true, // 禁用背景点击-->
<!--                    loadingType: 'spinner',-->
<!--                    message: '提交中...'-->
<!--                })-->
<!--                let data ={-->
<!--                    taskApply: this.declareInfo,-->
<!--                    body: this.body-->
<!--                }-->
<!--                try {-->
<!--                    const res = await this.$httpUtils.postGatewayUtils(taskApiMap.hzTsks,data)-->
<!--                    if (res.data.succ) {-->
<!--                        Toast.clear()-->
<!--                        if (this.informationShowData.mailingShow === 'Y') {-->
<!--                            Dialog.alert({-->
<!--                                title: '申报成功',-->
<!--                                message: `您的办件编号为:${res.data.data}`-->
<!--                            }).then(() => {-->
<!--                                this.$router.push('/myHandlingList')-->
<!--                            })-->

<!--                        } else {-->
<!--                            Dialog.alert({-->
<!--                                title: '申报成功，预审通过后，您可以携带相关办件材料至窗口办理',-->
<!--                                message: `您的办件编号为:${res.data.data}`-->
<!--                            }).then(() => {-->
<!--                                this.$router.push('/myHandlingList')-->
<!--                            })-->
<!--                        }-->

<!--                    } else {-->
<!--                        Toast.clear()-->
<!--                        if (res.data.status===201) {-->
<!--                            Toast.fail('申报失败，当天同一事项以申报两次达到限制请勿重复申报！')-->
<!--                        }else{-->
<!--                            Toast.fail('申报失败，当前网络波动请退出登录后重新申报！！！')-->
<!--                        }-->
<!--                    }-->
<!--                } catch (error) {-->
<!--                    console.log(error)-->
<!--                    Toast.clear()-->
<!--                }-->
<!--            },-->

<!--            /**-->
<!--             * 选择申请人出生日期-->
<!--             */-->
<!--            onConfirmBirthdayDate(value) {-->
<!--                this.body.data.csrq = dateToString(value, "yyyy-MM-dd")-->
<!--                this.showPickerBirthDate = false-->
<!--            },-->
<!--            /**-->
<!--             * 获取市-->
<!--             */-->
<!--            async getCityData(value) {-->
<!--                try {-->
<!--                    this.cityList = []-->
<!--                    this.areaList = []-->
<!--                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);-->
<!--                    let arr = [];-->
<!--                    if(res.data.succ = true){-->
<!--                        let d  = res.data.data-->
<!--                        for(var i =0;i < d.length;i++){-->
<!--                            arr.push({"title":d[i].regionname,"val":d[i].regioncode})-->
<!--                        }-->
<!--                    }-->
<!--                    this.cityList = arr-->
<!--                } catch (error) {-->
<!--                    Toast('服务器运行失败');-->
<!--                    console.log(error);-->
<!--                }-->
<!--            },-->
<!--            /**-->
<!--             * 获取地区-->
<!--             */-->
<!--            async getAreaData(value) {-->
<!--                try {-->
<!--                    this.areaList = []-->
<!--                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);-->
<!--                    let arr = [];-->
<!--                    if(res.data.succ = true){-->
<!--                        let d  = res.data.data-->
<!--                        for(var i =0;i < d.length;i++){-->
<!--                            arr.push({"title":d[i].regionname,"val":d[i].regioncode})-->
<!--                        }-->
<!--                    }-->
<!--                    this.areaList = arr-->
<!--                } catch (error) {-->
<!--                    Toast('服务器运行失败');-->
<!--                    console.log(error);-->
<!--                }-->
<!--            },-->
<!--            /**-->
<!--             *  机构省列表-->
<!--             */-->
<!--            onConfirmSqrProvince(value, index) {-->
<!--                this.sqrProvince = value.title-->
<!--                this.showSqrProvince = false-->
<!--                this.sqrCity = ''-->
<!--                this.sqrArea = ''-->
<!--                this.sqrCityShow = true-->
<!--                this.getCityData(value.val)-->
<!--            },-->
<!--            /**-->
<!--             *  机构市列表-->
<!--             */-->
<!--            onConfirmSqrCity(value, index) {-->
<!--                this.sqrCity = value.title-->
<!--                this.sqrArea = ''-->
<!--                this.showSqrCity = false-->
<!--                this.sqrAreaShow = true-->
<!--                this.getAreaData(value.val)-->
<!--            },-->
<!--            /**-->
<!--             *  机构区县列表-->
<!--             */-->
<!--            onConfirmSqrArea(value) {-->
<!--                this.sqrArea = value.title-->
<!--                this.showSqrArea = false-->
<!--            },-->
<!--            /**-->
<!--             * 选择申请人性别-->
<!--             */-->
<!--            onConfirmSex(value) {-->
<!--                this.sex = value.title-->
<!--                this.body.data.xb = value.val-->
<!--                this.showPickerSex = false-->
<!--            },-->

<!--            /**-->
<!--             * 传给定制化展示组件基本信息-->
<!--             */-->
<!--            sendCustomInfomation() {-->
<!--                const baseInfoList = [-->
<!--                    {title: '公安机关', prop: this.informationShowData.deptName},-->
<!--                    {title: '申请人', prop: this.informationShowData.name},-->
<!--                    {title: '性别', prop: this.informationShowData.sex},-->
<!--                    {title: '出生日期', prop: this.informationShowData.csrq},-->
<!--                    {title: '公民身份号码', prop: this.informationShowData.idNum},-->
<!--                    {title: '户籍地址', prop: this.informationShowData.address},-->
<!--                    {title: '所属派出所', prop: this.informationShowData.sspcs},-->
<!--                    {title: '现服役地', prop: this.informationShowData.xfyd},-->
<!--                    {title: '联系电话', prop: this.informationShowData.phone},-->
<!--                    {title: '联系地址', prop: this.informationShowData.linkAddress},-->
<!--                ]-->
<!--                this.baseInfoList = baseInfoList-->
<!--            },-->
<!--            /**-->
<!--             * 获取与拟落户人关系-->
<!--             */-->
<!--            getRelation(){-->
<!--                this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz_gx_docking`).then(res => {-->
<!--                    let arr =[];-->
<!--                    if (res.data.succ = true) {-->
<!--                        arr = res.data.data;-->
<!--                    }-->
<!--                    this.$nextTick(() => {-->
<!--                        this.relationList = arr-->
<!--                    })-->
<!--                }).catch(err => {-->

<!--                })-->
<!--            },-->
<!--        }-->
<!--    }-->
<!--</script>-->

<!--<style lang="less" scoped>-->
<!--    @import "~@assets/css/views/matter/declare/standard-matter/StandardMatter.less";-->
<!--</style>-->
<!--<style>-->
<!--    .text-danger{-->
<!--        color:red;-->
<!--    }-->
<!--</style>-->
